import React from 'react'
import loader from '@/assets/images/svg/loader.svg'
import { useTranslation } from 'react-i18next'

export const Loader = () => {
  const { t } = useTranslation()
  return (
    <div className="flex justify-center items-center mt-5">
      <img src={loader} alt={t('loader')} className="animate-spin h-5 w-5 text-white" />
    </div>
  )
}
